import type { InventoryTree } from '@scaleaq/sitecontrol-lib';

import type { GlobalInventorySite } from './inventory.types.ts';

export const buildScopedRoute = (
  route: string,
  inventoryId: string | undefined,
  parameters?: Record<string, string>
) => {
  const search = new URLSearchParams(parameters);
  if (inventoryId) search.set('inventoryId', inventoryId);
  const query = search.toString();
  return query ? `${route}?${query}` : route;
};

type SelectGlobalInventorySitesProps = {
  nodes: readonly Pick<InventoryTree, 'id' | 'name' | 'fields'>[] | undefined;
  /** The host this edge cluster is served on (`defaultSite.baseUrl`); absent in portable mode. */
  localBaseUrl: string | undefined;
};

/**
 * Sites from a by-type list. `SiteBase` is set by the cloud, so the edge site node may lack it. On
 * edge such a row gets the cluster's own host; in portable mode it cannot be addressed and is
 * dropped.
 */
export const selectGlobalInventorySites = ({
  nodes,
  localBaseUrl,
}: SelectGlobalInventorySitesProps): GlobalInventorySite[] | undefined => {
  if (!nodes) return undefined;
  return nodes.flatMap(node => {
    const siteBase = node.fields?.SiteBase || localBaseUrl;
    if (!siteBase) return [];
    return [{ id: node.id, name: node.name, fields: { SiteBase: siteBase } }];
  });
};
